import { useState } from 'react'
import { ScoopButton, ScoopSpinner, ScoopTextField } from '../../../ui'
import styles from './SignupForm.module.scss'
import { federatedSignIn } from '../../../../api/auth'
import GoogleIcon from '../../../../assets/account/GoogleIcon.svg'

export const SignupForm = ({
    onToggleMode,
    appSumoData,
    signUpUser,
    handleSignUpInputChange,
    handleSignUp,
    isSignUpLoading,
    errors,
    forceUserEmail,
    invitationEmail,
    hasInvitation,
}) => {
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = (event) => {
        event.preventDefault()
        handleSignUp()
    }

    const handleGoogleSignup = () => {
        try {
            window.dataLayer.push({ event: 'google_login_attempt' })
        } catch (e) {}
        federatedSignIn()
    }

    const togglePassword = () => {
        setShowPassword(!showPassword)
    }

    return (
        <div className={styles.signupContainer}>
            {appSumoData ? (
                <div className={styles.appSumoBox}>
                    <div className={styles.appSumoHeader}>🎉 Complete Your AppSumo Setup</div>
                    <div className={styles.appSumoDescription}>
                        Sign up to connect your license to your Scoop account
                    </div>
                </div>
            ) : hasInvitation ? (
                <div className={styles.formHeader}>
                    <span className={styles.trialBadge}>🎉 You're invited to join Scoop!</span>
                    <h2>Create Account to Join</h2>
                    <p>You've been invited to join a workspace</p>
                </div>
            ) : (
                <div className={styles.formHeader}>
                    <span className={styles.trialBadge}>Start Free Trial</span>
                    <h2>Get Started in Minutes</h2>
                    <p>No credit card required • Full access to all features</p>
                </div>
            )}

            {!forceUserEmail && !appSumoData && (
                <>
                    <div className={styles.socialLogin}>
                        <ScoopButton
                            variant="outline"
                            size="fullWidth"
                            onClick={handleGoogleSignup}
                            leftSection={
                                <img src={GoogleIcon} alt="Google" width="18" height="18" />
                            }
                        >
                            Continue with Google
                        </ScoopButton>
                    </div>

                    <div className={styles.divider}>
                        <span>or sign up with email</span>
                    </div>
                </>
            )}

            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="Full Name"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your full name"
                        value={signUpUser.fullName}
                        onChange={(e) => handleSignUpInputChange('fullName', e.target.value)}
                        disableMargin
                    />
                    {errors.fullName && <div className={styles.errorText}>{errors.fullName}</div>}
                </div>

                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="Work Email"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="you@company.com"
                        value={signUpUser.email}
                        onChange={(e) => handleSignUpInputChange('email', e.target.value)}
                        disableMargin
                        disabled={!!(forceUserEmail || invitationEmail)}
                    />
                    {errors.email && <div className={styles.errorText}>{errors.email}</div>}
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.passwordWrapper}>
                        <ScoopTextField
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            placeholder="Create a strong password"
                            value={signUpUser.password}
                            onChange={(e) => handleSignUpInputChange('password', e.target.value)}
                            disableMargin
                        />
                        <button
                            type="button"
                            className={styles.passwordToggle}
                            onClick={togglePassword}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </button>
                    </div>
                    <div className={styles.passwordHint}>Must be at least 8 characters</div>
                    {errors.password && <div className={styles.errorText}>{errors.password}</div>}
                </div>

                <ScoopButton
                    variant="default"
                    size="fullWidth"
                    type="submit"
                    disabled={isSignUpLoading}
                >
                    {isSignUpLoading ? (
                        <ScoopSpinner />
                    ) : appSumoData ? (
                        'Link AppSumo Account'
                    ) : (
                        'Start Free Trial'
                    )}
                </ScoopButton>

                <div className={styles.terms}>
                    By signing up, you agree to our{' '}
                    <a href="https://www.scoopanalytics.com/toc" target="_blank" rel="noreferrer">
                        Terms of Service
                    </a>{' '}
                    and{' '}
                    <a
                        href="https://www.scoopanalytics.com/privacy-policy"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Privacy Policy
                    </a>
                </div>
            </form>

            <div className={styles.loginLink}>
                Already have an account? <span onClick={onToggleMode}>Sign in</span>
            </div>
        </div>
    )
}
